<template>
  <v-dialog
    :value="internalValue"
    :max-width="330"
    @click:outside="onOkClickButton"
    @keydown.esc="onOkClickButton"
  >
    <v-card class="popup-wrapper">
      <div class="title">
        <jira-icon class='jira-integration'/>
        <span> {{$t(title)}} </span>
      </div>
      <div class="message">{{$t(message)}}</div>
      <div class='data' v-if='data'> {{ data }}</div>
      <div class="buttons">
        <v-btn small depressed class="ok-button" @click="onOkClickButton()">
          {{$t(okCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import JiraIcon from '@/assets/icons/systems/Jira.svg?inline';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'TicketingIntegrationPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    message: String,
    okCaption: String,
    internalValue: {
      type: Boolean,
      required: true,
    },
    data: String,
  },
  components: {
    JiraIcon,
  },
  methods: {
    onOkClickButton() {
      this.$emit('clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(380);
  padding: rem(32) rem(40);

  .title {
    display: flex;
    align-items: center;
    color: var(--text-primary);
    font-size: rem(14) !important;
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: rem(16);
    text-transform: uppercase;
    padding-bottom: rem(23);
    .jira-integration {
      margin-right: rem(7);
      max-width: rem(18);
      max-height: rem(18);
    }
  }

  .data .message {
    font-size: $font-size-base !important;
    line-height: 1.36 !important;
    font-weight: normal;
    color: var(--text-primary);

    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: rem(18);
  }

  .buttons {

    text-align: right;
    padding-top: rem(30);

    .ok-button {
      box-sizing: border-box;
      height: rem(32);
      width: rem(86);
      border-radius: $radius-sm;
      background-color: var(--brand-primary) !important;
      color: var(--text-inverse) !important;
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      box-shadow: $shadow-sm;
    }

  }

}

</style>
